/**
 * Hero before/after — product photo enhancement demo (aligned frame).
 * Replace compare-shoe.jpg with paired client exports when available.
 */
import compareShoe from "../assets/solutions/post-editing/compare-shoe.jpg";

export const postEditingCompare = {
    before: {
        src: compareShoe,
        alt: "Before — unedited product photograph with flat color and lighting",
    },
    after: {
        src: compareShoe,
        alt: "After — professionally color graded and enhanced product photograph",
    },
};

export const postEditingCompareUsesFilteredPair =
    postEditingCompare.before.src === postEditingCompare.after.src;
